module.exports = __webpack_public_path__ + "7f7c560184d935a117b66fc62e07f84e.png";